// extracted by mini-css-extract-plugin
export var callCard = "_rr-0";
export var callMessageButton = "_rr-1";
export var helpIcon = "_rr-3";
export var helpIconContainer = "_rr-4";
export var verticalDivider = "_rr-2";